import Model, { attr, belongsTo } from '@ember-data/model';
import type UserModel from './user.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class PhoneNumberModel extends Model {
  @attr declare number: string;
  @attr declare contactType: string;
  @attr declare phoneNumberType: string;
  @attr declare isActive: boolean;
  @attr declare isVerified: boolean;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('user', { async: false, inverse: null })
  declare user: UserModel;

  [Type] = 'phone-number' as const;
}
